import type { Fetcher } from 'swr';

import { getAxiosWithAuth } from '@/lib/axios';
import {
  type GetFeedbackData,
  getFeedbackDataSchema,
} from '@/types/database/feedback';

export const feedbacksFetcher: Fetcher<
  GetFeedbackData,
  [number, string]
> = async ([page, householdNumber]) => {
  const axios = getAxiosWithAuth();
  const { data } = await axios.get('/ezcon/api/feedbacks', {
    params: {
      householdNumber,
      page,
      pageSize: 200,
      order: 'descend',
      orderField: 'createdTime',
    },
  });
  const parseResult = getFeedbackDataSchema.safeParse(data.data);
  if (parseResult.success) {
    return parseResult.data;
  }
  console.error(parseResult.error);
  return [];
};
